export default (error: Strapi5Error, id = 'error', target?: ReturnType<typeof useToast>) => {
    // target — заранее захваченный toast: вызов вне Nuxt-контекста (plugin strapi-error
    // показывает ошибки в отложенном setTimeout, где useToast() уже недоступен)
    const toast = target ?? useToast()
    toast.clear()
    toast.add({
        id,
        icon: 'tabler:alert-square-rounded-filled',
        color: 'error',
        title: `${error.error?.status} ${error.error?.name}`,
        description: error.error?.message,
        duration: 5000
    })
}
